import firebase from "firebase/app"
import "firebase/auth"
import { firebaseConfig } from '../firebase'
import "firebase/analytics";

const firebaseEnv = process.env["REACT_APP_FIREBASE_ENV"] ?? 'production'
const isTest = process.env["NODE_ENV"] === 'test'
const isLocal = firebaseEnv === 'local' || isTest

const app = firebase.initializeApp(firebaseConfig[firebaseEnv])

// Analytics is a no-op against the local emulator and throws under jsdom in tests, so skip it locally.
export const analytics = isLocal ? undefined : app.analytics()
export const auth = app.auth()

if (isLocal) {
  const emulatorHost = process.env["REACT_APP_FIREBASE_LOCAL_EMULATOR_HOST"] ?? "http://localhost:9099"
  auth.useEmulator(emulatorHost)
}

export function getToken(): string | null {
  return localStorage.getItem('lf_tkn')
}

export function setToken(token: string) {
  localStorage.setItem('lf_tkn', token)
}

export default app
